'use strict';

angular.module('utils').factory('OCValidationUtil', function(PhoneUtils) {
  return {
    isValidEmail: function(email) {
      var regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regexp.test(email);
    },
    isValidWebsite: function(website) {
      return (/^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/).test(website.toLowerCase());
    },
    isValidPhoneNumber: function(phoneNumber) {
      if (!phoneNumber) {
        return false;
      }

      const formattedPhoneNumber = PhoneUtils.formatPhoneNumber(phoneNumber);

      // Validate the size of the phone number by adding 2 characters (+1) to a
      // 10 digit north american phone number.
      return formattedPhoneNumber.length == 12;
    },
    isHoursConfigured: function(hours) {
      if (!angular.isArray(hours) || !hours.length) {
        return false;
      }
      for (var i = 0; i < hours.length; i++) {
        if (hours[i].start || hours[i].end) {
          return true;
        }
      }
      return false;
    },
    urlFormat: function(url) {
      if (url) {
        url = url.toLowerCase();
      }
      if (url && !(/^https?:\/\/.+$/).test(url)) {
        return 'http://' + url;
      }
      return url;
    },

    isWholeDollarAmount: (value) => Number.isFinite(value) && value >= 0 && value % 1 === 0,
  };
});
